import { useContext, useState } from "react";
import Search from "./search";
import MobileNavbar from "./MobileNavbar";
import { Link } from "react-router-dom";
import { CartContext } from "../../providers/CartContextProvider";
import { FavoriteContext } from "../../providers/FavoriteContextProvider";
import { Authorization } from "../../providers/AuthContextProvider";

function HeaderIcon({ href, icon, text, children }) {
  return (
    <Link to={href} className="relative text-white group  text-xs">
      <div className="flex flex-col items-center">
        <div className='centerOfParent'>
          {icon}
        </div>
        <span className="whitespace-nowrap group-hover:text-[#f7ca77]">{text}</span>
      </div>
      {children}
    </Link>
  );
}

const menuItems = [
  { name: "خانه", path: "/" },
  { name: "سفارش تابلو", path: "/product?page=1" },
  { path: "/capillary-guidance", name: "پیشنهاد هوشمند" },
  { name: "هنرمندان", path: "/artists" },
  { name: "تابلو های اماده", path: "/ready-product?page=1" },
  // { name: "سبک های هنری", path: "/styles" },
  { name: "دسته بندی ها", path: "/categories" },
  { name: "مجله هنری", path: "/blogs?page=1" },
  { name: "درباره ما", path: "/about-us#main" },
  { name: "تماس با ما", path: "/contact#main" },
];
export default function HeaderSection() {
  const [openMenu, setOpenMenu] = useState(false);
  const { state } = useContext(CartContext)
  const { state: favrite } = useContext(FavoriteContext)
  const { user } = useContext(Authorization)

  return (
    <header className="bg-main text-white">
      <div className="container flex justify-between gap-8 p-4">
        <div className="flex items-center justify-between w-full lg:w-auto">
          <Link to="/" className="lg:w-[260px] lg:h-[126px] w-[130px] h-[63px] overflow-hidden centerOfParent">
            <img
              src="/images/Tonaliteh logo.png"
              width={100} height={100}
              style={{ width: '100%', height: 'auto' }} // optional
              alt="Tonaliteh Logo"
              className="py-2 object-contain"
            />
          </Link>

          <button className="lg:hidden centerOfParent w-[24px] h-[24px]" onClick={() => setOpenMenu((pre) => !pre)}> <svg className="w-full h-full" stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"></path></svg></button>
        </div>

        <div className="lg:flex items-center justify-center text-center w-full lg:w-auto hidden">
          <div className="pt-1">
            <span className="p-4 text-sm" dir="auto">
              {user?.first_name ? `خوش آمدید ${user.first_name}` : ''}
            </span>

            <hr className="my-1 bg-gray-600 opacity-50" />
            {/* desktop icons */}
            <div className="flex justify-center items-center space-x-4 pt-2 pb-1 ">
              <HeaderIcon
                href="/checkout/cart"
                icon={<img src='/images/icons/card.svg' width={28} height={28} alt="سبد خرید" />}
                text="سبد خرید">
                {!!state.itemsCounter && <p
                  style={{ lineHeight: 1.8 }}
                  className="bg-secondary text-white text-sm absolute top-0 right-0 w-[20px] h-[20px] rounded-full grid place-items-center">
                  {state.itemsCounter}
                </p>}
              </HeaderIcon>
              <HeaderIcon href="/favorite" icon={<img src='/images/icons/favorite.svg' alt="favorite" width={28} height={28} />} text="گالری شخصی">
                {!!favrite.itemsCounter && <p
                  style={{ lineHeight: 1.8 }}
                  className="bg-secondary text-white text-sm absolute top-0 right-0 w-[20px] h-[20px] rounded-full grid place-items-center">
                  {favrite.itemsCounter}
                </p>}
              </HeaderIcon>
              {!Object.keys(user).length ?
                <HeaderIcon href="/auth/login" icon={<svg className="w-7 h-7" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"></path></svg>} text="ورود" />
                : <HeaderIcon href={user.is_admin ? '/admin/information' : "/profile/information"} icon={<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"></path></svg>} text={"بخش کاربری"} />}
            </div>
            <hr className="my-1 bg-gray-600 opacity-50" />
          </div>
        </div>
      </div>

      <div className="bg-gray-800">
        <div className="container px-4 py-2 flex lg:flex-nowrap flex-wrap lg:gap-4 gap-2 justify-between items-center">
          {/* search */}
          <Search />
          {/* mobile icons */}
          <div className="md:hidden">
            <MobileNavbar />
          </div>
          {/* menu desktop */}
          <div
            dir="rtl"
            className="lg:flex gap-4 items-center hidden flex-grow"
          >
            {menuItems.map((item, i) => (
              <Link key={i} to={item.path} className={` text-sm duration-200 hover:scale-105 whitespace-nowrap`}>
                {i === 0 && <svg className="w-4 h-4 inline-block" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"></path></svg>} {item.name}
              </Link>
            ))}
          </div>

          {/* mobile menu */}
          {openMenu && (
            <div dir="rtl" className="grid lg:gap-2 gap-4 lg:hidden w-full ">
              {menuItems.map((item, i) => (
                <Link onClick={() => setOpenMenu((pre) => !pre)} key={i} to={item.path}>{item.name}</Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
